import { Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { apiClient } from '~admin/client';
import { MediaData } from '~admin/model/media-data';
import { mapMediaDataList } from '~admin/model/media-data.mapper';
import { AdminMediaResponse } from '~client/model/admin/admin-media-response';
import { MediaType } from '~client/model/media-type';
import { rxTask, TwoArgTask } from '~common/helper/mobx-tasks';

export type GetMediaListTask = TwoArgTask<string, MediaType, MediaData[]>;

/* Returns media list of media items that satisfies given query */
const performGetMediaList = (
  descriptionSearch: string,
  mediaType: MediaType,
): Observable<AdminMediaResponse[]> =>
  apiClient.mediaAdminController
    .getMediaList$(descriptionSearch, mediaType)
    .pipe(pluck('mediaList'));

export const getMediaListTaskFactory = (): GetMediaListTask =>
  rxTask<string, MediaType, MediaData[]>((descriptionSearch: string, mediaType: MediaType) =>
    performGetMediaList(descriptionSearch, mediaType).pipe(map(mapMediaDataList)),
  );



// WEBPACK FOOTER //
// ./interactor/media/perform-get-media-list.ts